module.exports = __webpack_public_path__ + "static/running.a96f05f1.png";